import React from "react";
import { Input, Card, Grid2 } from "@mui/material";
import SearchTwoToneIcon from "@mui/icons-material/SearchTwoTone";
import "../css/app.css";

export default function Search({ searchTerm, handleSearchChange, checked }) {
  return (
    <Card className={"appcards"}>
      <Grid2 container>
        <Grid2 size={{ xs: 2, sm: 2, md: 1 }}>
          <SearchTwoToneIcon
            sx={{
              color: "black",
              fontSize: "2em",
              paddingTop: "10px",
            }}
          />
        </Grid2>
        <Grid2 size={{ xs: 10, sm: 10, md: 11 }}>
          <Input
            disableUnderline
            placeholder={checked ? "Search Name" : "Search"}
            value={searchTerm}
            onChange={(event) => {
              handleSearchChange(event.target.value);
            }}
            sx={{
              color: "black",
              width: "29em",
              paddingTop: "0.6em",
            }}
          />
        </Grid2>
      </Grid2>
    </Card>
  );
}
